export function init(name) {
    const item = $(name);

    if (!item.length) {
        return;
    }

    if (!navigator.share) {
        item.remove();
        return;
    }

    item.click(function () {
        navigator.share({
            title: $(this).data('share-title'),
            url: $(this).data('share-url'),
        });
    });
}
